var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceSettingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.035,
    height: 21.036,
    viewBox: "0 0 21.035 21.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "gear-1",
    d: "M326.335,502.724v-2.833c-1.447-.514-2.361-.66-2.822-1.769h0c-.461-1.113.088-1.871.742-3.25l-2-2c-1.369.652-2.132,1.2-3.25.743h0c-1.111-.462-1.257-1.382-1.769-2.822H314.4c-.51,1.434-.656,2.359-1.77,2.822h0c-1.115.461-1.869-.086-3.25-.743l-2,2c.653,1.375,1.205,2.133.743,3.25h0c-.463,1.112-1.389,1.259-2.821,1.769v2.833c1.43.508,2.358.657,2.821,1.77h0c.464,1.124-.1,1.9-.743,3.249l2,2c1.371-.65,2.135-1.205,3.25-.741h0c1.112.461,1.26,1.383,1.77,2.82h2.834c.51-1.432.656-2.358,1.777-2.823h0c1.106-.461,1.858.087,3.242.744l2-2c-.65-1.371-1.205-2.132-.742-3.249S324.9,503.233,326.335,502.724Zm-10.519,2.091a3.506,3.506,0,1,1,3.508-3.507A3.507,3.507,0,0,1,315.816,504.815Z",
    transform: "translate(-305.3 -490.789)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceSettingIcon);
export default __webpack_public_path__ + "static/media/device-setting-icon.28767d31.svg";
export { ForwardRef as ReactComponent };